export default __webpack_public_path__ + "static/media/sample-grid-writer.51e68b40.svg";